import React from 'react'

import { TypeRichTextField } from '../../../utils/types'
import Storyblok from '../../../services/storyblok'
import reportError from '../../../services/errorReporting'

function createMarkup(storyblokHTML) {
  if (typeof storyblokHTML !== 'object') {
    reportError(storyblokHTML)

    return {
      __html: storyblokHTML,
    }
  }

  return {
    __html: Storyblok.richTextResolver.render(storyblokHTML),
  }
}

const RichTextField = ({ data }) => {
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={createMarkup(data)} />
}

RichTextField.propTypes = TypeRichTextField

export default RichTextField



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/atoms/RichTextField/RichTextField.js